import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "../../../Common/errorApiHandleUtils";
import { checkFilter } from "../../../Common/filterUtils";
import { categoryService } from "../../../Axios/categoryService";

export const getCategory = createAsyncThunk(
    'category/getCategory',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await categoryService.getCategory(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitCategory = createAsyncThunk(
    'category/submitCategory',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            data.about && formData.append('about', data.about);
            data.description && formData.append('description', data.description);
            data.banner && formData.append('banner', data.banner);

            let response;
            if (data.id) {
                response = await categoryService.updateCategory(data.id, formData);
            } else {
                response = await categoryService.createCategory(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteCategory = createAsyncThunk(
    'category/deleteCategory',
    async (id, { rejectWithValue }) => {
        try {
            const response = await categoryService.deleteCategory(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
